import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IProduct } from "../../models/catalogue";

type IProps = Immutable<{
    variant: IProduct | null;
}>;

export const ProductUnavailable = (props: IProps): React.JSX.Element | null => {
    let reasonMessage: string = t`This product does not come in this configuration`;
    if (props.variant) {
        if (props.variant.availability.is_available_to_buy) {
            return null;
        }
        reasonMessage = props.variant.availability.message;
    }
    return <div className="configurator__unavailable">{reasonMessage}</div>;
};
